// // import logo from "./logo.svg";
// // import "./App.css";
// // import Home from "./components/pages/Home";

// // function App() {
// //   return (
// //     <>
// //       <Home />
// //     </>
// //   );
// // }

// // export default App;

// import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
// import Home from "./components/pages/Home";

// import "./App.css";
// import Download from "./components/pages/Download";
// import Footer from "./components/Mainpages/Footer";

// function App() {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/download" element={<Download />} />
//       </Routes>
//       {/* <Footer /> */}
//     </Router>
//   );
// }

// export default App;

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/pages/Home";
import Download from "./components/pages/Download";
import Footer from "./components/Mainpages/Footer";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="app-container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/download" element={<Download />} />
        </Routes>
        {/* <Footer /> */}
      </div>
    </Router>
  );
}

export default App;
